export class FendtVarioDocHttp {
  static get $inject() {
    return ['$http', 'fendtConfig'];
  }

  constructor($http, { restVarioDocPath }) {
    this.$http = $http;
    this.basePath = restVarioDocPath;
  }

  /**
   * 'Plan' the booking operation with the given id.
   * The Fendt Bundle will send the operation data
   * to VarioDoc.
   * @param {String} operationId
   * UUID of booking operation
   * @returns {ng.HttpPromise}
   */
  plan(operationId) {
    return this.$http.post(`${this.basePath}/plan/${operationId}`);
  }

  /**
   * Check if a machine with the given serial number
   * is registered with VarioDoc.
   * @param {String} serial
   * @returns {ng.HttpPromise}
   */
  isRegistered(serial) {
    return this.$http.get(
      `${this.basePath}/registered/${encodeURIComponent(serial)}`
    );
  }
}
